import {TAllNewsItem} from "@/app/[locale]/news/types";

export const extractTextNewsFromJSON = (text:  TAllNewsItem[]) => {
    return text.map((el: TAllNewsItem) => {
        try {
            const parsedText = JSON.parse(el.text);
            const blocks = parsedText.blocks || [];
            const extractedText = blocks[2]?.text || blocks[0]?.text || "";
            return { ...el, text: extractedText };
        } catch (error) {
            console.error("Error parsing text for element:", el.id, error);
            return { ...el, text: "Error extracting text" };
        }
    });
};